<template>
    <transition name="fade">
        <div class="modal" :class="{'show':modal_show}" tabindex="-1" aria-hidden="true" v-if="modal_show">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{def.content_name}}</h5>
                        <button type="button" class="btn btn-round close" @click="close">
                            <i class="mdi mdi-close"></i>
                        </button>
                    </div>
                    <div class="modal-body p-3 content-container" v-html="def.content" v-if="def.hasOwnProperty.call(def, 'content')">
                    </div>
                    <div class="modal-body p-3" v-else>
                        <h6 class="opacity-5">Loading</h6>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn" @click="close">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

export default {
    data() {
        return {
            modal_show: false,
            data: '',
            def: {}
        }
    },
    methods: {
        close() {
            this.modal_show = false;
            this.data = '';
            this.def = {};
        },
        async load() {
            const url = new URL(this.data);
            let params = url.searchParams;
            let id = '';
            if(params.get('c') !== null) id = params.get('c');
            else if(params.get('content') !== null) id = params.get('content');

            this.def = await this.$axios.get(`/content/vikipedia/${id}/uid`)
                                .then((res) => {
                                    if(res.status == 200 && res.data[0] !== undefined) {
                                        return res.data[0];
                                    }
                                    else return {};
                                })
                                .catch(() => {
                                    return {};
                                })
        }
    },
    mounted() {
        this.$emitter.on('show_definition', (data) => {
            this.modal_show = true;
            if(data !== undefined) {
                this.data = data;
                this.load();
            }
            else this.data = '';
        });
    }
}
</script>

<style scoped>
.modal::after {
    background: #000;
    content: '';
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    z-index: -1;
    opacity: 0.5;
}

.modal.show {
    display: block;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}


.text-primary {
    color: var(--primary-color) !important;
}

.custom-input, .custom-input::placeholder {
    font-size: 14px;
}
</style>